import { DatePipe } from '@angular/common';
import { Component, Input, forwardRef, ViewEncapsulation, ViewChild, ElementRef, OnInit, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { SabisTranslateService } from '../translation/sdp-translate.service';

@Component({
  selector: 'sabis-ngx-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SabisNgxDatepickerComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SabisNgxDatepickerComponent),
      multi: true,
    }
  ]
})
export class SabisNgxDatepickerComponent implements OnInit, ControlValueAccessor, Validator, IDisableable {

  @Input('scPlaceholder') scPlaceholder: string | undefined ;
  @Input('scLabel') scLabel: string | undefined;
  @Input('scFormat') scFormat: string = 'dd/MM/yyyy';
  @Input('min') min: Date | undefined;
  @Input('max') max: Date | undefined;
  @Input('scHideValidationMessage') scHideValidationMessage: boolean = false;

  isDisabled: boolean | undefined;
  fieldSetDisabled: boolean | undefined;

  isValid: boolean = true;
  validationMessage: string | undefined;
  value: Date | undefined;
  pipe = new DatePipe('en-US');

  @Output('scOnBlur') scOnBlur: EventEmitter<void> = new EventEmitter<void>(false);

  @ViewChild('datePicker') datePicker: MatDatepicker<any> | undefined;

  private onTouchedCallback = () => { };
  private onChangeCallback = (value: Date) => { };

  constructor(private _translateService: SabisTranslateService) { }

  ngOnInit() {
    if (!this.scFormat) {
      this.scFormat = 'dd/MM/yyyy';
    }
  }

  onDatePickerChange(value: Date) {
    if (this.value !== value) {
      //check date format to return date as formater
      if (value) {
        if (this.scFormat.search('h') == -1 && this.scFormat.search('H') == -1) {
          value.setHours(0);
        }
        if (this.scFormat.search('m') == -1) {
          value.setMinutes(0);
        }
        if (this.scFormat.search('s') == -1 && this.scFormat.search('S') == -1) {
          value.setSeconds(0);
        }
      }
      this.value = value;

      if (this.onChangeCallback) {
        this.onChangeCallback(this.value);
      }
    }
  }
  setDisable(value: boolean): void {
    this.fieldSetDisabled = value;
  }

  focus() {
    this.datePicker?.restoreFocus;
  }

  onDatePickerFocus() {
    if (this.onTouchedCallback) {
      this.onTouchedCallback();
    }
  }

  onDatePickerBlur() {
    // turn around to clear the date input when one of the date value is not set (e.g: day-02-2018)
    if (this.value == null) {
      this.value = new Date();
      setTimeout(() => {
        this.value = undefined;
      });
    }
    this.scOnBlur.emit();
  }

  writeValue(date: Date): void {
    if (date) {
      this.value = new Date(date);
    }
    else {
      this.value = date;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(c: AbstractControl): { [key: string]: any; } {
    this.setValidationMessage(c);
    // Add minValue and maxValue custom  validation
    //var value = c.value;
    if (this.max && c.value && c.value > this.max) {
      return {
        maxValue: {
          valid: false,
          requiredValue: this.max,
          actualValue: c.value
        },
      };
    }
    if (this.min && c.value && c.value < this.min) {
      return {
        minValue: {
          valid: false,
          requiredValue: this.min,
          actualValue: c.value
        },
      };
    }
    return {};
  }

  registerOnValidatorChange?(fn: () => void): void {

  }
  private setValidationMessage(c: AbstractControl): void {
    //set Time out because the control changes validation after passing in the validate function
    setTimeout(() => {
      this.isValid = c.errors == null;
      if (!this.isValid) {
        for (var e in c.errors) {
          //this.validationMessage = c.errors[e];
          if (e == "required") {
            this.validationMessage = this._translateService.instant("SabisComponents.FieldRequired");
          }
          else if (e == "maxValue") {
            this.validationMessage = this._translateService.instant("SabisComponents.MaxValueIs") + " " + this.pipe.transform(this.max, this.scFormat);
          }
          else if (e == "minValue") {
            this.validationMessage = this._translateService.instant("SabisComponents.MinValueIs") + " " + this.pipe.transform(this.min, this.scFormat);
          }
          else {
            this.validationMessage = "";
          }
        }
      }
    });
  }

  /** Get displayed value from Datepicker */
  public getFormattedValue(): string {
    const value = this.value;
    const format = this.scFormat;

    return this.pipe.transform(value, format)!;
  }
}


export interface IDisableable {

  setDisable(value: boolean): void;
}

